// extracted by mini-css-extract-plugin
export var quillEditor = "_n4-1";
export var variable = "_n4-0";